import Button from '../../common/buttons/Button';
import Link from '../../common/Link/Link';
import PropTypes from 'prop-types';
import React from 'react';

const HeroBanner = ({ content, breakpoint }) => {
  try {
    const image =
      breakpoint === 'mobile'
        ? content.structuredImageData.mobile.imageURL
        : content.structuredImageData.desktop.imageURL;

    const altText =
      breakpoint === 'mobile'
        ? content.structuredImageData.mobile.altText
        : content.structuredImageData.desktop.altText;

    return (
      <div
        className={`dsg-flex flex-column HeroBanner ${content.cta && content.cta[0] && 'has-cta'}`}>
        {content.link && content.link.length > 1 ? (
          <a href={content.link} alt={content.altText} data-em={content.DataEMTag}>
            <img src={image} alt={altText} loading="lazy" />
          </a>
        ) : (
          <img src={image} alt={altText} loading="lazy" />
        )}
        <div className="dsg-flex flex-column justify-content-center HeroBanner-textOverlay">
          <p className="HeroBanner-textOverlay-headline">{content.headline}</p>
          <p className="HeroBanner-textOverlay-subtext">
            {content.description}
            {content.optionalDetailsLink && content.optionalDetailsLink.length > 0 && (
              <span>
                {' '}
                <Link
                  text="Details"
                  classes={['details-link']}
                  tabIndex={0}
                  ariaLabel="view available details for this banner"
                  href={content.optionalDetailsLink}
                  inline={false}
                  secondary
                />
              </span>
            )}
          </p>
          {content.cta && content.cta[0] && (
            <div className="HeroBanner-textOverlay-buttonWrapper">
              <Button
                variant="marketing"
                label={content.cta[0].linkTitle}
                onClick={() => (window.location.href = content.cta[0].link)}
              />
            </div>
          )}
        </div>
      </div>
    );
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default HeroBanner;
